import LocalDetails from "./local-detials-config";
import DocumentDetails from "../card/document-details-config";


const VALIDATION = {
    presence : {
        key : 'presence',
        value : {
            message: function(t){ return t("error.presence");}
        }
    },
    email : {
        key : 'email',
        value : {
            message: function(t){ return t("error.column.email.main");}
        }
    },
    vpa : {
        key : 'vpa',
        value : {
            message: function(t){ return t("hp_v3.direct_debit.upi_id.invalid");}
        }
    },
    no_validation()  {
        return {
            key : 'no_validation',
        }
    },
    min_max(min, max)  {
        return {
            key : 'length',
            value : {
                minimum: min,
                maximum: max,
                message: function(t) {
                    return fillPH(t("error.column.string.length.min_max"), {min:min, max:max})
                }
            }
        }
    },
    max(max)  {
        return {
            key : 'length',
            value : {
                maximum: max,
                message: function(t) {
                    return fillPH(t("error.column.string.length.max"), {max:max})
                }
            }
        }
    },
    min(min)  {
        return {
            key : 'length',
            value : {
                minimum: min,
                message: function(t) {
                    return fillPH(t("error.column.string.length.min"), {min:min})
                }
            }
        }
    },
    fixed(len)  {
        return {
            key : 'length',
            value : {
                is: len,
                message: function(t) {
                    return fillPH(t("error.column.string.length.fixed_length"), {min:len})
                }
            }
        }
    }
}

var field = function(type, name, labelKey,order){
    return {
        type: type,
        name: name,
        label: function(t){return t(labelKey);},
        order: order || 0,
        extra: "",
        required: true,
        read_only: false,
        short_field:false,
        validations: {},

        attachValidation: function(validations) {
            validations = validations || [];
            let no_validation = validations.filter(v => v.key == "no_validation")[0]
            if(no_validation != undefined) return validations;
            if(this.required) {
                validations.push(VALIDATION.presence)
            }
            if(this.type == 'text' && this.name == 'email') {
                validations.push(VALIDATION.email)
            }
            if(validations && validations.length > 0) {
                validations.forEach(e => {
                    this.validations[e.key] = e.value;
                });
            }
        }

    };
}

var baseField = function(type, name, order, validations, extra) {
    extra = extra || {};
    var f = Object.assign(field(type, name, getLabelI18NKey(name, {scheme : extra.scheme}), order), extra.override);
    f.attachValidation(validations);
    delete f.attachValidation;
    return f;
}

var textField = function(name, order, validations, extra){
    return baseField('text', name, order, validations, extra);
}

var hiddenField = function(name, order, validations, extra){
    return baseField('hidden', name, order, validations, extra);
}

var selectField = function(name, order, validations, extra){
    return baseField('select', name, order, validations, extra);
}

var emailField = function(name, order, validations, extra){
    return baseField('text', name, order, validations, extra);
}

var numericField = function(name, order, validations, extra){
    return baseField('number', name, order, validations, extra);
}

var phoneField = function(name, order, validations, extra){
	return baseField('tel', name, order, validations, extra);
}

var addressField = function(name, order, subFields = [], extra = {}){
    const fields =  baseField('address', name, order, [], extra);
    fields.sub_fields = subFields;
    return fields;
}

var regionField = function(name, order, subFields = [], extra = {}){
    const fields =  baseField('region', name, order, [], extra);
    fields.sub_fields = subFields;
    return fields;
}

var flatten = function(o) {
    var flat = [];
    Object.keys(o).forEach(k => {
        if(o[k] instanceof Array) {
            o[k].forEach(e => {
                flat.push(e);
            });
        }
    })
    return flat;
}

var fillPH = function(output, placeholders) {
    if(output && placeholders) {
        Object.keys(placeholders).forEach((key) => {
            output = output.replace(`%\{${key}\}`, placeholders[key]);
        });
    }
    return output;
}

var getLabelI18NKey = function(name, extra) {
    extra = extra || {};
    switch(name) {
        case "first_name":
            return (extra.scheme == 'ACH' && !['GOCARDLESS', "BLUESNAP", "BRAINTREE"].includes(extra.gateway_name)) ? "hp_v3.direct_debit.name_on_account" : "hp_v3.direct_debit.first_name";
        case "last_name":
            return "hp_v3.direct_debit.last_name";
        case "company":
            return "hp_v3.direct_debit.company";
        case "email":
            return "hp_v3.direct_debit.email";
        case "iban":
            return "hp_v3.direct_debit.iban";
        case "issuing_country":
            return "hp_v3.direct_debit.country"
        case "account_number":
            return "hp_v3.direct_debit.account_number"
        case "bank_code":
            if(extra.scheme == 'ACH'){
                return "hp_v3.direct_debit.routing_number";
            } else if(extra.scheme == 'PAD'){
                return "hp_v3.direct_debit.institution_number";
            } else if(extra.scheme == 'BECS(NZ)'){
                return "hp_v3.direct_debit.prefix";
            }
            return "hp_v3.direct_debit.bank_code"
        case "bank_name":
            return "hp_v3.direct_debit.bank_name"
        case "routing_number":
            if(extra.scheme == 'ACH'){
                return "hp_v3.direct_debit.routing_number";
            } else if(extra.scheme == 'BECS'){
                return "hp_v3.direct_debit.bsb_number";
            } else if(extra.scheme == 'PAD'){
                return "hp_v3.direct_debit.transit_number";
            } else if(extra.scheme == 'BACS'){
                return "hp_v3.direct_debit.sort_code";
            }
            return "hp_v3.direct_debit.branch_code";
        case "swedish_identity_number":
            return "hp_v3.direct_debit.swedish_id";
        case "account_type":
            return "hp_v3.direct_debit.account_type";
        case "account_holder_type":
            return "hp_v3.direct_debit.account_holder_type";
        case "verification_amount_1":
            return "hp_v3.direct_debit.stripe.verification_amount_1";
        case "verification_amount_2":
            return "hp_v3.direct_debit.stripe.verification_amount_2";
        case "creditor_name":
            return "direct_debit.creditor_name";
        case "date_of_authorization":
            return "direct_debit.date_of_authorization";
        case "direct_debit_user_id":
            return "direct_debit.direct_debit_user_id";
        case "merchant_name":
            return "direct_debit.merchant_name";
        case "authorisation_code":
            return "direct_debit.authorisation_code";
        case "suffix":
            return "hp_v3.direct_debit.suffix";
        case "checking":
            return "direct_debit.account_type.checking";
        case "saving":
            return "direct_debit.account_type.savings";
        case "business_checking":
            return "direct_debit.account_type.business_checking";
        case 'holder_type.individual':
            return 'direct_debit.account_holder_type.individual'
        case 'holder_type.company':
            return 'direct_debit.account_holder_type.company'
        case 'owner_name':
            return 'hp_v3.bank_based_payments.owner_name'
        case 'owner_email':
            return 'hp_v3.direct_debit.email'
        case 'owner_country':
            return 'hp_v3.direct_debit.country'
        case 'beneficiary_name':
            return 'hp_v3.netbanking.beneficiary_name'
        case 'email':
            return 'hp_v3.netbanking.email'
        case 'phone':
            return 'hp_v3.netbanking.phone'
        case 'account_number':
            return 'hp_v3.netbanking.account_number'
        case 'ifsc_code':
            return 'hp_v3.netbanking.ifsc_code'
        case 'bank':
            return 'hp_v3.netbanking.selected_bank'
        case 'account_type':
            return 'hp_v3.netbanking.account_holder_type'
        case 'phone':
            return 'hp_v3.direct_debit.phone'
        case 'vpa':
            return 'hp_v3.direct_debit.upi_id'
        case 'tax_id':
            return 'hp_v3.boleto.tax_id'
        case 'billing_addr1':
            return 'billing.line1.label'
        case 'billing_addr2':
            return 'billing.line2.label'
        case 'billing_addr3':
            return 'billing.line3.label'
        case 'billing_city':
            return 'billing.city.label'
        case 'billing_zip':
            return 'billing.zip.label'
        case 'billing_region':
            return 'billing.region.label'
        case 'billing_state':
            return 'billing.region.label'
        case 'billing_country':
            return 'billing.country.label'
        case 'document_number':
            return 'hp_v3.card.document_number'
        case 'document_type':
            return 'hp_v3.card.document_type'
     }
}

export default {

    configFields(fields, t) {
        fields.forEach(f => {
            this._transformFieldObject(f, t);
        });
        return fields;
    },

    getI18n(name, scheme) {
        return getLabelI18NKey(name, scheme)
    },

    _transformFieldObject(obj, t){
        Object.keys(obj).forEach(key => {
            if(obj[key] instanceof Function){
            obj[key] = obj[key](t);
            } else if (obj[key] instanceof Object){
            this._transformFieldObject(obj[key], t);
            }
        });
    },

    getCountryCodes(pm) {
        return LocalDetails.getList(pm);
    },

    getDocumentTypesCodes(pm) {
        return DocumentDetails.getList(pm);
    },

    getCardTypesCodes() {
        return  [
            {
                display_name: "Credit Card",
                value: "credit_card",
            },
            {
                display_name: "Debit Card",
                value: "Debit",
            },
            ]
    },

    getVerifyPmFieldConfig() {
        return [
            numericField("verification_amount_1", 0),
            numericField("verification_amount_2", 1),
        ];
    },

    getGoCardlessFieldConfig(pm, showName, showIban, selectedCountry, extra) {
      if (!pm || !pm.configuration) return [];
      let local_fields = [];
      if (!showIban) {
          let countries = this.getCountryCodes(pm);
          let country = countries.filter(c => c.value == selectedCountry)[0] || countries[0];
          local_fields = flatten(country.local_fields) || [];
          selectedCountry = country.value;
      }
      let openBankingEnabled = pm.configuration.open_banking_enabled;
      switch (pm.configuration.scheme) {
          case 'SEPA':
              return this.getGocardlessSEPAFields(showName, showIban, selectedCountry, local_fields, openBankingEnabled);
          case 'BACS':
              return this.getGocardlessBACSFields(showName, showIban, selectedCountry, local_fields, openBankingEnabled);
          case 'Autogiro':
              return this.getGocardlessAUTOGIROFields(showName, selectedCountry, local_fields);
          case 'ACH':
              return this.getGocardlessACHFields(showName, selectedCountry, extra);
          case 'BECS':
              return this.getGocardlessBECSFields(showName, selectedCountry, openBankingEnabled);
          case 'PAD':
              return this.getGocardlessPADFields(showName, selectedCountry);
          case 'BECS(NZ)':
              return this.getGocardlessBECS_NZFields(showName, selectedCountry);
      }
    },

    getCyberSourceFieldConfig(pm, selectedCountry, extra) {
        if (!pm || !pm.configuration) return [];
        let local_fields = [];
        let countries = this.getCountryCodes(pm);
        let country = countries.filter(c => c.value == selectedCountry)[0] || countries[0];
        local_fields = flatten(country.local_fields) || [];
        selectedCountry = country.value;
        switch (pm.configuration.scheme) {
            case 'ACH':
                return this.getCyberSourceACHFields(selectedCountry, extra);
        }
      },

    getStripeFieldConfig(pm, extra = {}) {
      const pm_type = pm && pm.type
      switch(pm_type) {
        case 'ideal':
          return this.getStripeIDealFields()
        case 'sofort':
          return this.getStripeSofortFields(pm)
        case 'bancontact':
          return this.getStripeBancontactFields()
        case 'direct_debit':
          const scheme = pm.configuration && pm.configuration.scheme
          switch(scheme) {
            case 'SEPA':
              return this.getStripeSepa(extra);
            case 'ACH':
              return this.getStripeAch(extra);
            case 'BACS':
              return this.getStripeBACS(extra);
            case 'BECS':
              return this.getStripeBECS(extra);
          }
          break;
        case 'boleto':
        return this.getStripeBoletoFields()
      }
      return [];
    },

    getCheckoutComFieldConfig(pm, extra = {}) {
        const pm_type = pm && pm.type
        switch(pm_type) {
          case 'bancontact':
            return this.getCheckoutComBancontactFields(pm)
        case 'direct_debit':
            const scheme = pm.configuration && pm.configuration.scheme
            switch(scheme) {
                case 'SEPA':
                return this.getCheckoutComSepa();
            }
        }
        return [];
      },

      getEbanxFieldConfig(pm, extra = {}) {
        if(pm && pm.type && pm.type === 'card') {
            return this.getDocumentRelatedCardFields(pm, false)
        }
        return [];
      },

      getDlocalFieldConfig(pm, extra = {}) {
        if(pm && pm.type && pm.type === 'card') {
            return this.getDocumentRelatedCardFields(pm, true)
        }
        return [];
      },

    getBluesnapFieldConfig(pm, extra = {}) {
        const pm_type = pm && pm.type
        switch(pm_type) {
          case 'direct_debit':
            const scheme = pm.configuration && pm.configuration.scheme
            switch(scheme) {
              case 'SEPA':
                return this.getBluesnapSepa();
            case 'ACH':
                return this.getBluesnapAch(extra);
            }
        }
        return [];
    },

    getBraintreeFieldConfig(pm, extra = {}) {
        extra = extra || {};
        if((pm && pm.configuration && pm.configuration.scheme === "ACH")) {
            return this.getBraintreeAch(extra);
        }
        return [];
    },

    getAuthorizeNetFieldConfig(pm, extra) {
        extra = extra || {};
        if((pm && pm.configuration && pm.configuration.scheme == "ACH")) {
            return this.getAuthorizeNetAch(extra);
        }
        return [];
    },

    getChargebeePaymentsFieldConfig(pm, extra) {
        extra = extra || {};
        if((pm && pm.configuration && pm.configuration.scheme == "ACH")) {
            return this.getChargebeePaymentsAch(extra);
        }
        return [];
    },

    getAdyenFieldConfig(pm, extra = {}) {
			const pm_type = pm && pm.type
			switch(pm_type) {
				case 'direct_debit':
					const scheme = pm.configuration && pm.configuration.scheme
					switch(scheme) {
						case 'SEPA':
							return this.getAdyenSepa(extra);
						case 'BACS':
							return this.getAdyenBacs();
                        case 'ACH':
                            return this.getAdyenAch(extra);
					}
			}
			return [];
    },

    getMollieFieldConfig(pm, extra) {
        extra = extra || {};
        if(pm && pm.configuration && pm.configuration.scheme == "SEPA") {
            return this.getMollieSepa();
        }

        const pm_type = pm && pm.type
        switch(pm_type) {
          case 'bancontact':
            return this.getMollieBancontactFields(pm)
        }
        return [];
    },

    getRazorpayFieldConfig(pm, extra) {
        extra = extra || {};
        const pm_type = pm && pm.type
        switch(pm_type) {
            case "netbanking_emandates":
                return this.getRazorpayNetbankingFields(pm)
            case "upi":
                return this.getRazorpayUpi()
        }
        return [];
    },

    getGatewayFieldConfig(pm, extra = {}) {
      const gateway = (pm && pm.gateway_name) || ''
      switch(gateway.toLowerCase()) {
        case 'stripe':
          return this.getStripeFieldConfig(pm)
        case 'checkout_com':
         return this.getCheckoutComFieldConfig(pm)
        case 'mollie':
         return this.getMollieFieldConfig(pm)
        case 'ebanx':
         return this.getEbanxFieldConfig(pm)
        case 'dlocal':
         return this.getDlocalFieldConfig(pm)
      }
      return []
    },

    getBoletoFieldConfig(pm) {
      return this.getStripeBoletoFields(pm);
    },

    _pushNameCompany(fields, showName, i) {
        if(showName) {
            fields.push(textField("first_name", i++, [VALIDATION.max(150)]));
            fields.push(textField("last_name", i++, [VALIDATION.max(150)]));
        } else {
            fields.push(textField("company", i++, [VALIDATION.max(250)]));
        }
        return i;
    },

    _pushName(fields, i) {
        fields.push(textField("first_name", i++, [VALIDATION.max(150)]));
        fields.push(textField("last_name", i++, [VALIDATION.max(150)]));
        return i;
    },

    _pushCountryField(fields, selectedCountry, i, read_only) {
        let override = {def_value: selectedCountry};
        if(read_only) {
            override['read_only'] = true;
        }
        fields.push(selectField("issuing_country", i++, [],{override: override}));
    },

    _pushLocalDetails(fields, selectedCountry, local_fields, i, read_only) {
        this._pushCountryField(fields, selectedCountry, i, read_only)
        local_fields.forEach(e => {
            let validations = [];
            if(e == 'account_number') {
                validations.push(VALIDATION.min_max(5, 17));
            } else if (e == 'routing_number') {
                validations.push(VALIDATION.min_max(3, 15));
            } else if(e =='bank_code') {
                validations.push(VALIDATION.max(20));
            }
            fields.push(textField(e, i++, validations));
        })
        return i;
    },

    getGocardlessSEPAFields(showName, showIban, selectedCountry, local_fields, openBankingEnabled) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        if(openBankingEnabled) {
            this._pushCommonOpenBankingFields(fields, selectedCountry, i);
        }
        if(showIban) {
            fields.push(textField("iban", i++, [VALIDATION.min_max(10, 50)]));
        } else {
            this._pushLocalDetails(fields, selectedCountry, local_fields, i);
        }
        return fields;
    },

    getGocardlessBACSFields(showName, showIban, selectedCountry, local_fields, openBankingEnabled) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        if(openBankingEnabled) {
            this._pushCommonOpenBankingFields(fields, selectedCountry, i);
        }
        if(showIban) {
            fields.push(textField("iban", i++, [VALIDATION.min_max(10, 50)]));
        } else {
            this._pushLocalDetails(fields, selectedCountry, local_fields, i, true);
        }
        return fields;
    },

    _pushCommonOpenBankingFields(fields, selectedCountry, i) {
        this._pushCountryField(fields, selectedCountry, i);
        fields.push(hiddenField("bank_name", i++, [VALIDATION.no_validation()]));
        fields.push(hiddenField("bank_id", i++, [VALIDATION.no_validation()]));
    },

    getStripeBACS(extra) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, extra.showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(6, 7)], { scheme: "BACS" }));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 9)]));
        return fields;
    },

    getGocardlessAUTOGIROFields(showName, selectedCountry, local_fields) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(textField("swedish_identity_number", i++, [VALIDATION.min_max(10, 12)]));
        this._pushLocalDetails(fields, selectedCountry, local_fields, i, true);
        return fields;
    },

    getCyberSourceACHFields(selectedCountry, extra) {
        let i = 0;
        let fields = [];
        i = this._pushName(fields, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(selectField("issuing_country", i++, [], { override: { def_value: selectedCountry, read_only: true }}));
        fields.push(textField("account_type", i++, [], { override: { def_value: extra.accountType } }));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(4, 9)], { scheme: "ACH" }));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(4, 17)]));
        return fields;
    },

    getGocardlessACHFields(showName, selectedCountry, extra) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(selectField("issuing_country", i++, [], { override: { def_value: selectedCountry, read_only: true }}));
        fields.push(textField("account_type", i++, [], { override: { def_value: extra.accountType } }));
        fields.push(textField("bank_code", i++, [VALIDATION.min_max(9, 9)], { scheme: "ACH" }));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(0, 17)]));
        return fields;
    },
    getGocardlessBECSFields(showName, selectedCountry, openBankingEnabled) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(selectField("issuing_country", i++, [], { override: { def_value: selectedCountry, read_only: true }}));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(6, 7)], { scheme: "BECS" }));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 9)]));
        if(!openBankingEnabled) {
            fields.push(textField("bank_name", i++,[VALIDATION.no_validation()]));
        }
        return fields;
    },

    getStripeBECS(extra) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, extra.showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(6, 7)], { scheme: "BECS" }));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 9)]));
        return fields;
    },

    getGocardlessPADFields(showName, selectedCountry) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(selectField("issuing_country", i++, [], { override: { def_value: selectedCountry, read_only: true }}));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(2, 10)], { scheme: "PAD" }));
        fields.push(textField("bank_code", i++, [VALIDATION.min_max(3, 10)], { scheme: "PAD" }));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(7, 12)]));
        return fields;
    },
    getGocardlessBECS_NZFields(showName, selectedCountry) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(selectField("issuing_country", i++, [], { override: { def_value: selectedCountry, read_only: true }}));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(4, 4)], { scheme: "BECS(NZ)" }));
        fields.push(textField("bank_code", i++, [VALIDATION.min_max(2, 2)], { scheme: "BECS(NZ)" }));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(7, 7)]));
        fields.push(textField("suffix", i++, [VALIDATION.min_max(2, 3)]));
        fields.push(textField("bank_name", i++,[VALIDATION.no_validation()]));
        return fields;
    },

    getAdyenSepa(extra){
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, extra.showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(textField("iban", i++, [VALIDATION.min_max(10, 50)]));
        return fields;
    },

    getAdyenBacs() {
      return [
        textField("first_name", 0, [VALIDATION.max(150)]),
        textField("last_name", 1, [VALIDATION.max(150)]),
        textField("routing_number", 2, [VALIDATION.min_max(6, 7)], { scheme: "BACS" }),
        textField("account_number", 3, [VALIDATION.min_max(5, 9)])
      ];
    },

    getMollieSepa() {
        return [
            textField("first_name", 0, [VALIDATION.max(150)]),
            textField("last_name", 1, [VALIDATION.max(150)]),,
            textField("iban", 3, [VALIDATION.min_max(10, 50)]),
        ];
    },

    getBluesnapSepa() {
        return [
            textField("first_name", 0, [VALIDATION.max(150)]),
            textField("last_name", 1, [VALIDATION.max(150)]),
            emailField("email", 2, [VALIDATION.max(70)]),
            textField("iban", 3, [VALIDATION.min_max(10, 50)]),
        ];
    },

    getCheckoutComSepa() {
        return [
            textField("first_name", 0, [VALIDATION.max(150)]),
            textField("last_name", 1, [VALIDATION.max(150)]),
            textField("iban", 3, [VALIDATION.min_max(10, 50)]),
        ];
    },

    getStripeSepa(extra) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, extra.showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(textField("iban", i++, [VALIDATION.min_max(10, 50)]));
        return fields;
    },

    getBluesnapAch(extra) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, extra.showName, i);
        fields.push(emailField("email", 2, [VALIDATION.max(70)]));
        fields.push(selectField("account_type", i++, [], {override: {def_value: extra.accountType}}));
        fields.push(selectField("account_holder_type", i++, [], {override: {def_value: extra.accountHolderType, read_only: true}}));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(3, 15)], {scheme: "ACH"}));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 17)]));
        return fields;
	},

    getStripeAch(extra) {
        let i = 0;
        let fields = [];
        fields.push(textField("first_name", i++, [VALIDATION.max(150)], {scheme: "ACH"}));
        fields.push(textField("bank_name", i++, [VALIDATION.max(100)]));
        let override = {def_value: extra.accountHolderType};
        fields.push(textField("account_holder_type", i++, [], {override: override}));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(3, 15)], {scheme: "ACH"}));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 17)]));
        return fields;
    },

    getBraintreeAch(extra) {
        let i = 0;
        let fields = [];
        i = this._pushNameCompany(fields, extra.showName, i);
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(phoneField("phone", i++, [VALIDATION.max(150)]));
        fields.push(selectField("account_type", i++, [], {override: {def_value: extra.accountType}}));
        fields.push(selectField("account_holder_type", i++, [], {override: {def_value: extra.accountHolderType, read_only: true}}));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(3, 15)], {scheme: "ACH"}));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 17)]));
        return fields;
    },

    getAuthorizeNetAch(extra) {
        let i = 0;
        let fields = [];
        fields.push(textField("first_name", i++, [VALIDATION.max(150)], {scheme: "ACH"}));
        fields.push(textField("bank_name", i++, [VALIDATION.max(100)]));
        let override = {def_value: extra.accountType};
        fields.push(textField("account_type", i++, [], {override: override}));
        fields.push(textField("routing_number", i++, [VALIDATION.min_max(3, 15)], {scheme: "ACH"}));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 17)]));
        return fields;
    },

    getChargebeePaymentsAch(extra) {
        let i = 0;
        let fields = [];
        fields.push(textField("first_name", i++, [VALIDATION.max(150)], {scheme: "ACH"}));
        let override = {def_value: extra.accountType};
        fields.push(textField("account_type", i++, [], {override: override}));
        fields.push(textField("routing_number", i++, [VALIDATION.fixed(9)], {scheme: "ACH"}));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(6, 18)]));
        return fields;
    },

  getAdyenAch(extra) {
    let i = 0;
    let fields = [];
    fields.push(textField("first_name", i++, [VALIDATION.max(150)]));
    fields.push(textField("last_name", i++, [VALIDATION.max(150)]));
    let override = {def_value: extra.accountType};
    fields.push(textField("account_type", i++, [], {override: override}));
    fields.push(textField("routing_number", i++, [VALIDATION.fixed(9)], {scheme: "ACH"}));
    fields.push(textField("account_number", i++, [VALIDATION.min_max(6, 18)]));
    return fields;
  },

    getStripeIDealFields(pm) {
      let i = 0;
      let fields = [];
      fields.push(textField("owner_name", i++, [VALIDATION.max(150)]));
      fields.push(emailField("owner_email", i++, [VALIDATION.max(70)]));
      return fields;
    },

    getStripeSofortFields(pm) {
      let i = 0;
      let fields = [];
      fields.push(textField("owner_name", i++, [VALIDATION.max(150)]));
      fields.push(emailField("owner_email", i++, [VALIDATION.max(70)]));
      fields.push(selectField("owner_country", i++, [], {
        override: { allowed_values: this.getCountryCodes(pm) }
      }));
      return fields;
    },

    getStripeBancontactFields(pm) {
      let i = 0;
      let fields = [];
      fields.push(textField("owner_name", i++, [VALIDATION.max(150)]));
      fields.push(emailField("owner_email", i++, [VALIDATION.max(70)]));
      return fields;
    },

    getCheckoutComBancontactFields(pm) {
        let i = 0;
        let fields = [];
        fields.push(textField("owner_name", i++, [VALIDATION.max(150)]));
        fields.push(selectField("owner_country", i++, [], {
            override: { allowed_values: this.getCountryCodes(pm) }
        }));
        return fields;
      },

      getDocumentRelatedCardFields(pm, isRequired) {
        let i = 0;
        let fields = [];
        fields.push(selectField("document_type", i++, [], {
            override: {required: isRequired, allowed_values: this.getDocumentTypesCodes(pm) }
        }));
        fields.push(textField("document_number", i++, [VALIDATION.max(150)],{override: {required: isRequired}}));
        return fields;
      },

      getMollieBancontactFields(pm) {
        let i = 0;
        let fields = [];
        fields.push(textField("owner_name", i++, [VALIDATION.max(150)]));
        return fields;
      },

    getRazorpayNetbankingFields(pm) {
        let i = 0;
        let fields = [];
        fields.push(textField("beneficiary_name", i++, [VALIDATION.min_max(4, 120)]));
        fields.push(emailField("email", i++, [VALIDATION.max(70)]));
        fields.push(phoneField("phone", i++, [VALIDATION.max(150)]));
        fields.push(textField("account_number", i++, [VALIDATION.min_max(5, 20)]));
        fields.push(textField("ifsc_code", i++, [VALIDATION.min(11)]));
        fields.push(selectField("bank", i++, []));
        // This is used to show bank name on review screen
        fields.push(hiddenField("bank_name", i++, []));
        fields.push(selectField("account_type", i++, []));
        return fields;
    },

    getRazorpayUpi() {
        return [
            textField("first_name", 0, [VALIDATION.max(150)]),
            textField("last_name", 1, [VALIDATION.max(150)]),
            emailField("email", 2, [VALIDATION.max(70)]),
            phoneField("phone", 3, [VALIDATION.min(8)]),
            textField("vpa", 4, [VALIDATION.vpa]),
        ];
    },

    getStripeBoletoFields(pm) {
        return [
            textField("first_name", 0, [VALIDATION.max(150)], { override: { short_field: true }}),
            textField("last_name", 1, [VALIDATION.max(150)], { override: { short_field:true }}),
            emailField("email", 2, [VALIDATION.max(70)]),
            textField("tax_id", 5, [VALIDATION.min(11)], { override: { short_field:false }}),
            phoneField("phone", 3, [], { override: { short_field:false, required: false, def_value: "+55" }}),
            textField("company", 4, [], {override: { short_field:false, required: false }}),
            addressField("billingAddress", -1, [
                textField("billing_addr1", 6, [VALIDATION.max(150)], { override: { short_field:false }}),
                textField("billing_addr2", 6, [], { override: { short_field:false }}),
                textField("billing_city", 6, [VALIDATION.max(50)], { override: { short_field: true }}),
                textField("billing_zip", 6, [VALIDATION.max(20)], { override: { short_field:true }}),
                regionField("billing_region", 6, [
                    textField("billing_state", 0, [VALIDATION.max(50)], { override: { short_field: true }}),
                    selectField("billing_state_code", 0, [VALIDATION.max(50)], { override: { short_field: true }})
                ], { override: { short_field: true, extra: "{\"country_name\":\"billing_country\"}" }}),
                selectField("billing_country", 6, [VALIDATION.max(50)], { override: {
                    short_field:true,
                    allowed_values: [{
                      "display_name": "Brazil",
                      "value": "BR"
                    }],
                    def_value: "BR"
                }}),
            ], { override: { use_billing_address: true }})
        ];
    },
}
